/**
 * Created by yiren on 2019-09-04
 * local storage tool
 */

import store from 'store/dist/store.modern';
import {CONTRACT, FROM,NET,MAINNET,TESTNET} from "../config/constant";

export function storeContractAddress(address) {
    store.set(CONTRACT, address);
    console.log(`stored Contract: ${address}`);
}

export function getContractAddress() {
    return storeGet(CONTRACT);
}

export function storeFromAddress(address) {
    store.set(FROM, address);
    console.log(`stored from: ${address}`);
}

export function getFromAddress() {
    return storeGet(FROM)
}

export function storeGet(key) {
    const value = store.get(key);
    if (typeof value === 'undefined') {
        return '';
    }
    return value;
}

export function storeSetNet(value) {
    store.set(NET,value);
}